import { usd } from "../../../../util/formatCurrency.js";
import s from "./HeroProductStack.module.css";

export default function HeroProductStack({ products }) {
  const items = (products || []).slice(0, 3);

  if (!items.length) return null;

  return (
    <div className={s.visual} aria-hidden="true">
      <div className={s.bg} />
      <div className={s.stack}>
        {items.map((p) => (
          <div key={p.product_id} className={s.product}>
            <div className={s.productHead}>
              <span>{p.product_type || ""}</span>
            </div>
            <div className={s.productImage}>
              {p.image_url && <img src={p.image_url} alt="" loading="lazy" />}
            </div>
            <div className={s.productFoot}>
              <span className={s.productName}>{p.name}</span>
              <span className={s.productPrice}>{usd(p._totalPrice)}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
